import store from '@/stores/index'
import { ROLE_CONSTS as RC } from '@/utilities/appConsts'
import { USER_CONSTS as UC } from '@/stores/consts'

export const role = RC

export function hasRole(role) {
  if (Array.isArray(role)) {
    const rolesRequired = role.map(role => role.name)
    const userRoles = store.state[UC.NAMESPACE].roles.map(role => role.name)
    const hasOneOfTheseRoles = userRoles.filter(userRole => {
      return rolesRequired.includes(userRole)
    })
    return hasOneOfTheseRoles.length > 0
  } else {
    return store.state[UC.NAMESPACE].roles.map(r => r.name).includes(role.name)
  }
}

export function hasRoleByName(name) {
  const roles = store.state[UC.NAMESPACE].roles
  const check = roles.map(r => r.name).includes(name)
  return check
}
